import { render, staticRenderFns } from "./ModalidadPage.vue?vue&type=template&id=e4d9de24"
import script from "./ModalidadPage.js?vue&type=script&lang=js&external"
export * from "./ModalidadPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports